module.exports = __webpack_public_path__ + "static/media/programa_publico_natalia.64f7ca51.jpg";